import { Component, OnInit } from '@angular/core';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { UserService } from '../../shared/services/user.service';
import { first } from 'rxjs/operators';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { User } from '../../shared/models/user.model';
import { TranslateService } from '@ngx-translate/core';
import { AppConfig } from 'src/app/shared/services/app.config';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { Languages } from 'src/app/shared/models/enums.model';
@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {
  resetPasswordForm: FormGroup;
  loading = false;
  submitted = false;
  responseObject: ResponseObject;
  userName: string = '';
  sitekey=AppConfig.settings.apiServer.captchaSiteKey;
  user: User = new User();
  resendActivation = false;
  marked = false;
  showResendLink: boolean = false;
  showRequest=false;
  
  emailRegex: string = '^[a-zA-Z0-9._-]+@[a-zA-Z0-9-]+(\\.)[a-zA-Z0-9-.]+$';
  displayedLang: Languages;
  lang: string='en';
  
  constructor(
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    private userService: UserService,
    private router: Router,
    private authSrevice: AuthenticationService,
    private translate: TranslateService,
    private globalSrv: GlobalServices ) {
      this.displayedLang = this.globalSrv.getLanguage();
      if (this.displayedLang == Languages.Arabic) {
          this.lang='ar';
      }
      else{
          this.lang='en';
      } 
      
    this.user = this.authSrevice.currentUserValue;
    if (this.user) {
      this.router.navigate(['']);
    }

  }

  ngOnInit() {
    this.buildForm();
  }

  buildForm() {
    this.resetPasswordForm = this.formBuilder.group({
      username: ['', [Validators.required, Validators.pattern(this.emailRegex)]],
      recaptcha: ['', Validators.required]
    });
  }


  get f() {
    return this.resetPasswordForm.controls;
  }

  onSubmit() {
    this.submitted = true;
    if (this.resetPasswordForm.invalid) {
      return;
    }
    this.loading = true;
    
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    this.userName = this.resetPasswordForm.controls.username.value;
    this.userService.SendResetPassword(this.userName)
      .pipe(first())
      .subscribe(
        (data: ResponseObject) => {
          this.responseObject = data;
          if (this.responseObject.Success) {
            
            this.globalSrv.isLoaderEnabled = false;
            this.showResendLink = true;
            this.showRequest=true;
            //this.alertService.success(this.translate.instant('FRONT_USER.SUCCESS_MESSAGES.RESET_PASSWORD'), false);
            // this.router.navigateByUrl('/userprofile');
            //this.router.navigate(['/forgetpassword']);
            this.loading = false;
          }
          else {
            this.showRequest=false;
            this.globalSrv.isLoaderEnabled = false;
            this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.'+this.responseObject.ErrorMessages[0]), false);
         
            this.loading = false;
          }

        });
  }

  toggleVisibility(e) {
    // this.marked = e.target.checked;
    // if (this.marked) {
      
    this.alertService.clear();
      this.userService.ResendResetMail(this.userName)
        .pipe(first())
        .subscribe(
          (data: ResponseObject) => {
            this.responseObject = data;
            if (this.responseObject.Success) {

              this.alertService.success(this.translate.instant('FRONT_USER.SUCCESS_MESSAGES.RESEND_LINK'), false);
            }
            else {
              this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.InternalServerError'), false);
           
            }
          });
    // }
  }
}
